/**
 * Returns the Supabase edge function URL for a given function name.
 * All AI features use Supabase edge functions as the single code path.
 */
export function getAIApiUrl(functionName: string): string {
  return `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/${functionName}`;
}
